export default (tracker) => ({
  async stepViewed(step) {
    await tracker.track('Step Viewed', {
      stepTitle: step.stepTitle,
      currentStepNumber: step.currentStepNumber,
      totalStepCount: step.totalStepCount,
      interactionSection: step.interactionSection,
      interactionCategory: step.interactionCategory,
    })
  },
})
